module.exports = __webpack_public_path__ + "static/media/demonslayermanga.fce67017.png";